import httpClient from "@/services/httpClient";
import {
  server
} from "@/services/constants";

export const getDataCurrency = (pch_id) => {
    return httpClient.get(server.CURRENCY_URL);
  };